export const POINTS_REWARD_FOR_ITEM = "POINTS REWARD FOR ITEM"
export const REFUND_SALES_ITEMS = "REFUND SALES ITEMS"
export const POINTS_REDEMPTION = "POINTS REDEMPTION"
export const SV_PRELOAD = "SV PRELOAD"
export const SV_RELOAD = "SV RELOAD"
export const SV_REDEMPTION = "SV REDEMPTION"
export const SV_PLUS_ADJUSTMENT = "SV PLUS ADJUSTMENT"
export const SV_MINUS_ADJUSTMENT = "SV MINUS ADJUSTMENT"
export const SALES = "SALES"
export const ITEM_REDEMPTION = "ITEM REDEMPTION"
export const REBATE_REDEMPTION = "REBATE REDEMPTION"
export const VOUCHER_ISSUANCE_WITH_POINTS = "VOUCHER ISSUANCE WITH POINTS"
export const VOUCHER_REDEMPTION = "VOUCHER REDEMPTION"
export const PLUS_ADJUSTMENT = "PLUS ADJUSTMENT"
export const MINUS_ADJUSTMENT = "MINUS ADJUSTMENT"
export const POINTS_EXPIRY = "POINTS EXPIRY"
export const ADDITIONAL_REWARDS = "ADDITIONAL REWARDS"
export const TRANSFER = "TRANSFER"
export const IN = "IN"



// WEBPACK FOOTER //
// ./src/constants/transactionType.js